import { create } from 'zustand'

import { Notification, TimedNotification } from '../types'

interface NotificationsState {
  notifications: Notification[]
  addNotfication: (notification: TimedNotification) => void
  removeNotfication: (uuid: string) => void
}

const useNotificationStore = create<NotificationsState>((set) => ({
  notifications: [],
  addNotfication: (notification) =>
    set((state) => ({ notifications: [notification, ...state.notifications] })),
  removeNotfication: (uuid) =>
    set((state) => ({
      notifications: state.notifications.filter((notification) => notification.uuid !== uuid),
    })),
}))

export default useNotificationStore
